import { render, staticRenderFns } from "./questionContent.vue?vue&type=template&id=2b792084&scoped=true&"
import script from "./questionContent.vue?vue&type=script&lang=js&"
export * from "./questionContent.vue?vue&type=script&lang=js&"
import style0 from "./questionContent.vue?vue&type=style&index=0&id=2b792084&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b792084",
  null
  
)

export default component.exports